'use strict';

var base = require('base/checkout/formErrors');

/**
 * Clear the form errors.
 * @param {string} parentSelector - the parent form selector.
 */
base.clearPreviousErrors = function(parentSelector) {
    $(parentSelector).find('.form-control.is-invalid').removeClass('is-invalid');
    $(parentSelector).find('.invalid-feedback').empty();
    $('.error-message').hide();
}

module.exports = base;
